import posthog from 'posthog-js';

declare global {
  interface Window {
    fbq?: (action: string, eventName: string, params?: Record<string, unknown>) => void;
    __suppressTracking?: boolean;
  }
  interface Navigator {
    globalPrivacyControl?: boolean;
  }
}

const POSTHOG_TOKEN = 'phc_JbeT65rS2die3UsObhf2fNWxK0mvVIkvY5piSubJRv8';
const POSTHOG_API_HOST = 'https://us.i.posthog.com';

function isPrerender(): boolean {
  if (typeof navigator === 'undefined') return true;
  return /ReactSnap/i.test(navigator.userAgent);
}

// Suppress non-essential analytics/advertising for visitors who send a Global
// Privacy Control opt-out signal, or who appear to be in the EU/UK (by timezone).
// public/index.html computes the same rule into window.__suppressTracking before
// the bundle loads; we read that, and recompute defensively in case it didn't run.
function shouldSuppressTracking(): boolean {
  if (typeof window === 'undefined') return true;
  if (window.__suppressTracking) return true;
  if (typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true) return true;
  try {
    if (window.localStorage && window.localStorage.getItem('dink_tracking_optout') === '1') return true;
  } catch (e) {
    /* localStorage unavailable: fall through */
  }
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz.indexOf('Europe/') === 0) return true;
  } catch (e) {
    /* Intl unavailable: fall through to allowing analytics */
  }
  return false;
}

let initialized = false;

export function initAnalytics(): void {
  if (initialized || isPrerender() || typeof window === 'undefined') return;
  if (shouldSuppressTracking()) return;
  initialized = true;

  posthog.init(POSTHOG_TOKEN, {
    api_host: POSTHOG_API_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
  });
}

export function isAnalyticsEnabled(): boolean {
  return initialized;
}

export function trackPageview(url?: string): void {
  if (isPrerender() || typeof window === 'undefined') return;

  const href = url ?? window.location.href;

  if (initialized) {
    posthog.capture('$pageview', { $current_url: href });
  }

  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
}

export { posthog };
